import { Controller, useForm } from "react-hook-form";
import { v4 as uuidV4 } from "uuid";
import { states } from "js/placeholderData/states";
import { screenScrollTo } from "js/utilities";
import FormInputError from "components/General/FormInputError";
import MaskedPhoneNumberInput from "components/General/Form/MaskedPhoneNumberInput";
import { useTranslation } from "react-i18next";
import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";
import { useState } from "react";

export default function FACStepFive({ formStep, setFormStep, setFACFormData }) {
  const {
    register: FACStepFiveRegister,
    handleSubmit: FACStepFiveHandleSubmit,
    setValue,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      funeralHomePhoneNumber: "",
    },
  });
  const uuid = uuidV4();
  const { t } = useTranslation();
  const [selectedState, setSelectedState] = useState({ value: "all" });

  const onSubmit = (data) => {
    // screenScrollTo();
    setFormStep(6);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep === 5 && (
        <>
          <div>
            <p className="text-sm">{t("FACStep-five-title")}</p>

            <form onSubmit={FACStepFiveHandleSubmit(onSubmit)}>
              <hr />
              <div className="mt-6 grid gap-4 grid-cols-1 lg:gap-6">
                <div className="grid gap-4 grid-cols-1 ">
                  <div>
                    <label htmlFor={`${uuid}-fh-name`} className="block mb-1">
                      {t("FACStep-five-name")}
                    </label>
                    <input
                      id={`${uuid}-fh-name`}
                      type="text"
                      placeholder="Funeral Home Name"
                      {...FACStepFiveRegister(`funeralHomeName`)}
                    />
                  </div>
                </div>

                <div className="md:w-4/5">
                  <label
                    htmlFor={`${uuid}-fh-streetAddress`}
                    className="block mb-1"
                  >
                    {t("FACStep-five-street-address")}
                  </label>
                  <input
                    id={`${uuid}-fh-streetAddress`}
                    type="text"
                    placeholder="Funeral Home Street Address"
                    {...FACStepFiveRegister(`funeralHomeStreetAddress`)}
                  />
                </div>

                <div className="md:w-4/5">
                  <label
                    htmlFor={`${uuid}-fh-streetAddress2`}
                    className="block mb-1"
                  >
                    {t("FACStep-five-street-address-2")}
                  </label>
                  <input
                    id={`${uuid}-fh-streetAddress2`}
                    type="text"
                    placeholder="Funeral Home Street Address Line 2"
                    {...FACStepFiveRegister(`funeralHomeStreetAddress2`)}
                  />
                </div>

                <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
                  <div>
                    <label htmlFor={`${uuid}-fh-city`} className="block mb-1">
                      {t("FACStep-five-city")}
                    </label>
                    <input
                      id={`${uuid}-fh-city`}
                      type="text"
                      placeholder="Funeral Home City"
                      {...FACStepFiveRegister("funeralHomeCity")}
                    />
                  </div>

                  <div>
                    <Controller
                      name="funeralHomeState"
                      control={control}
                      render={() => (
                        <RELEASING_AutoCompleteComboBox
                          labelName={t("FACStep-five-state")}
                          inputPlaceholderText={t("FACStep-five-state-optn")}
                          options={[
                            {
                              value: "all",
                              displayAs: t("FACStep-five-state-optn"),
                              selectedPolicyDisplayAs: t(
                                "FACStep-five-state-optn"
                              ),
                              isDisplayOnly: true,
                            },
                            ...states.map((state) => ({
                              value: state.abbreviation,
                              displayAs: state.name,
                              selectedPolicyDisplayAs: state.name,
                              isDisplayOnly: true,
                            })),
                          ]}
                          selectedOption={selectedState}
                          setSelectedOption={(option) => {
                            setSelectedState(option);
                            if (option?.value !== "all") {
                              setValue("funeralHomeState", option.value);
                            } else {
                              setValue("funeralHomeState", "");
                            }
                          }}
                        />
                      )}
                    />
                  </div>

                  <div>
                    <label htmlFor={`${uuid}-fh-zip`} className="block mb-1">
                      {t("FACStep-five-zip")}
                    </label>
                    <input
                      id={`${uuid}-fh-zip`}
                      type="text"
                      placeholder="Zip Code"
                      {...FACStepFiveRegister("funeralHomeZip", {
                        pattern: {
                          value: /^\d{5}$/,
                          message: "Please enter a valid zipcode (5 digits)",
                        },
                        maxLength: {
                          value: 5,
                          message: "Please enter only 5 digits for zipcode",
                        },
                      })}
                    />
                    <FormInputError
                      errorMessage={errors.funeralHomeZip?.message}
                    />
                  </div>
                </div>

                <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
                  <div>
                    <label id={`${uuid}-phone-claimer`} className="block mb-1">
                      {t("FACStep-five-phone")}
                    </label>
                    <MaskedPhoneNumberInput
                      name="funeralHomePhoneNumber"
                      describedby={`${uuid}-phone-claimer`}
                      register={FACStepFiveRegister}
                      setValue={setValue}
                      required={false}
                    />
                    <FormInputError
                      errorMessage={errors.funeralHomePhoneNumber?.message}
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  className="ui-btn-secondary ui-btn-min-w mt-4"
                  type="button"
                  onClick={() => setFormStep(4)}
                >
                  {t("FACStep-two-btn-1")}
                </button>

                <button className="ui-btn-primary ui-btn-min-w mt-4">
                  {t("FACStep-two-btn-2")}
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </>
  );
}
